<template>
  <div ref="rootRef" class="rich-html-case rich-html-case--intelligentElectricAdjustmentSystem">
    <!-- Top Banner (poster1.html) -->
    <section class="poster-banner">
      <div class="poster">
        <img
          class="poster__image"
          :src="posterBanner"
          alt="RC模型智能电调控制平台"
          @error="onImageError"
        />
      </div>
    </section>

<!-- Project Introduction -->
<section class="project-intro">
  <div class="project-intro__inner">
    <img class="project-intro__title-img" :src="introduceText" alt="项目介绍" />
    <p class="project-intro__text fontRegular">{{ projectIntroduction }}</p>
  </div>
</section>

<!-- Case Detail Hero (case_detail.html) -->
<section class="detail-hero">
  <div class="container">
    <div class="detail-hero__inner">
      <div class="detail-hero__text">
        <div class="detail-hero__tag">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
          </svg>
          智能电调控制系统
        </div>
        <h1 class="detail-hero__title">RC模型<span>智能电调</span><br />控制平台</h1>
        <p class="detail-hero__subtitle">
          专为遥控模型车设计的专业级电调参数配置与实时监控平台，支持深度参数定制、转速计算、多模式适配与历史数据回溯。
        </p>
        <div class="detail-hero__stats">
          <div class="detail-hero__stat">
            <div class="detail-hero__stat-value">50+</div>
            <div class="detail-hero__stat-label">可调参数</div>
          </div>
          <div class="detail-hero__stat">
            <div class="detail-hero__stat-value">4</div>
            <div class="detail-hero__stat-label">核心功能模块</div>
          </div>
          <div class="detail-hero__stat">
            <div class="detail-hero__stat-value">∞</div>
            <div class="detail-hero__stat-label">自定义模式</div>
          </div>
        </div>
        <div class="detail-hero__platforms">
          <span class="detail-hero__platform">
            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M18.71 19.5C17.88 20.74 17 21.95 15.66 21.97C14.32 21.99 13.89 21.18 12.37 21.18C10.84 21.18 10.37 21.95 9.09997 21.99C7.78997 22.03 6.79997 20.68 5.95997 19.47C4.24997 17 2.93997 12.45 4.69997 9.39C5.56997 7.87 7.12997 6.91 8.81997 6.88C10.1 6.86 11.32 7.75 12.11 7.75C12.89 7.75 14.37 6.68 15.92 6.84C16.57 6.87 18.39 7.1 19.56 8.82C19.47 8.88 17.39 10.1 17.41 12.69C17.44 15.74 20.06 16.78 20.09 16.79C20.07 16.85 19.67 18.23 18.71 19.5ZM13 3.5C13.73 2.67 14.94 2.04 15.94 2C16.07 3.17 15.6 4.35 14.9 5.19C14.21 6.04 13.07 6.7 11.95 6.61C11.8 5.46 12.36 4.26 13 3.5Z" /></svg>
            iOS
          </span>
          <span class="detail-hero__platform">
            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M17.523 15.341c-.5-.823-1.339-1.46-2.525-1.46-.77 0-1.416.365-1.91.607-.327.161-.65.315-1.003.315-.39 0-.73-.168-1.093-.348-.49-.25-1.01-.51-1.763-.51-1.156 0-1.98.63-2.49 1.454A5.43 5.43 0 0 0 6 18c0 1.42.53 2.72 1.41 3.69A4.86 4.86 0 0 0 11 23h2a4.86 4.86 0 0 0 3.59-1.31A5.43 5.43 0 0 0 18 18c0-1.07-.29-2.07-.477-2.659zM15 3a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3zm-3.5 8a3 3 0 0 0-3 3v2h7v-2a3 3 0 0 0-3-3z" /></svg>
            Android
          </span>
          <span class="detail-hero__platform">
            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z" /></svg>
            HarmonyOS
          </span>
        </div>
      </div>
      <div class="detail-hero__visual">
        <div class="phone-mockup">
          <div class="phone-outer">
            <div class="phone-screen">
              <div class="phone-notch"></div>
              <div class="status-bar">
                <div class="status-bar-left"><span>9:41</span></div>
                <div class="status-bar-right">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="#fff"><path d="M2 4h3l2 4V4h3V0H2v4zm0 8h12v-1H2v1z" /></svg>
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="#fff"><rect x="1" y="2" width="12" height="8" rx="1.5" stroke="#fff" stroke-width="1" fill="none" /><path d="M14 4.5V7c0 .8-.7 1.5-1.5 1.5H13V4.5h1z" fill="#fff" /><rect x="2.5" y="3.5" width="9" height="5" rx="0.5" fill="#fff" /></svg>
                </div>
              </div>
              <div class="app-ui">
                <div class="app-nav">
                  <div class="nav-back">&lt;</div>
                  <div class="nav-title">Parameters</div>
                  <div class="nav-icon">&#x1F4F1;</div>
                </div>
                <div class="dropdown-bar">
                  <div class="dropdown-label">Current Data</div>
                  <div class="dropdown-arrows"><span>&#x2304;</span><span>&#x2303;</span></div>
                </div>
                <div class="mode-list">
                  <div class="mode-item"><div class="mode-name">Mode 1</div><div class="mode-edit">&#9998;</div></div>
                  <div class="mode-item"><div class="mode-name">Mode 2</div><div class="mode-edit">&#9998;</div></div>
                  <div class="mode-item"><div class="mode-name">Mode 3</div><div class="mode-edit">&#9998;</div></div>
                  <div class="add-mode-btn">+ Add mode</div>
                </div>
                <div class="settings-section">
                  <div class="section-spacer"></div>
                  <div class="setting-item"><div class="setting-name">Running Mode</div><div class="setting-value">Forward w/ Brake &#x203A;</div></div>
                  <div class="setting-item"><div class="setting-name">Max. Reverse Force</div><div class="setting-value">50%</div></div>
                  <div class="setting-item"><div class="setting-name">Cutoff Voltage</div><div class="setting-value">Adjustable 7.2V</div></div>
                  <div class="setting-item"><div class="setting-name">ESC Thermal Protection</div><div class="setting-value">105&#xB0;C &#x203A;</div></div>
                  <div class="setting-item"><div class="setting-name">Motor Thermal Protect.</div><div class="setting-value">100&#xB0;C &#x203A;</div></div>
                  <div class="setting-item"><div class="setting-name">BEC voltage</div><div class="setting-value">6.0V &#x203A;</div></div>
                  <div class="setting-item"><div class="setting-name">Remote Off</div><div class="setting-value">Disabled &#x203A;</div></div>
                  <div class="setting-item"><div class="setting-name">Sensor mode</div><div class="setting-value">Full Sensor &#x203A;</div></div>
                  <div class="setting-item"><div class="setting-name">Phase-AC Swap</div><div class="setting-value"></div></div>
                </div>
                <div class="tab-bar">
                  <div class="tab-item active">
                    <div class="tab-icon">&#x2699;</div>
                    <div class="tab-label">参数设置</div>
                  </div>
                  <div class="tab-item">
                    <div class="tab-icon">&#x25BD;</div>
                    <div class="tab-label"></div>
                  </div>
                  <div class="tab-item">
                    <div class="tab-icon">&#x2302;</div>
                    <div class="tab-label"></div>
                  </div>
                  <div class="tab-item">
                    <div class="tab-icon">&#x26F6;</div>
                    <div class="tab-label"></div>
                  </div>
                  <div class="tab-item">
                    <div class="tab-icon">&#x2699;</div>
                    <div class="tab-label"></div>
                  </div>
                </div>
                <div class="popup-overlay">
                  <div class="bottom-sheet">
                    <div class="sheet-header">
                      <div class="sheet-title">Running Mode</div>
                      <div class="sheet-close">&times;</div>
                    </div>
                    <div class="sheet-option">Forward with Brake</div>
                    <div class="sheet-option active">Forward / Reverse with Brake</div>
                    <div class="sheet-option">Reverse with Brake</div>
                    <div class="sheet-option">Forward and Reverse</div>
                    <div class="sheet-confirm">Confirm</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="page-detail">
<!-- Overview -->
<section class="overview">
  <div class="container">
    <div class="overview-grid">
      <div class="overview-card">
        <div class="overview-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg></div>
        <h3>深度参数定制</h3>
        <p>提供 50+ 项可调参数，涵盖运行模式、油门曲线、刹车力度、进角控制等全方位调节能力。</p>
      </div>
      <div class="overview-card">
        <div class="overview-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2v4m0 12v4M4.93 4.93l2.83 2.83m8.48 8.48l2.83 2.83M2 12h4m12 0h4M4.93 19.07l2.83-2.83m8.48-8.48l2.83-2.83"/></svg></div>
        <h3>实时数据监控</h3>
        <p>圆形仪表盘直观展示速度、油门、电压、电流、温度六大核心指标，毫秒级刷新。</p>
      </div>
      <div class="overview-card">
        <div class="overview-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/><line x1="4" y1="22" x2="4" y2="15"/></svg></div>
        <h3>多模式管理</h3>
        <p>支持创建无限个自定义驾驶模式，一键切换不同场景下的最佳参数组合。</p>
      </div>
    </div>
  </div>
</section>

<!-- Features -->
<section class="features">
  <div class="container">
    <div class="section-header">
      <div class="section-label">Core Features</div>
      <h2 class="section-title">四大核心能力</h2>
    </div>
    <div class="features-grid">
      <div class="feature-card">
        <span class="feature-number">01</span>
        <div class="feature-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg></div>
        <h3>深度参数定制</h3>
        <p>提供超过 50 项可调参数，覆盖 General Settings（运行模式、截止电压、热保护阈值）、Throttle Rate Control（Punch 控制、油门曲线、Neutral Range、软启动）、Brake Settings（刹车模式/力度/频率）及 Timing Angle（Boost/Turbo 进角系统）四大维度。</p>
        <div class="feature-tags">
          <span class="feature-tag">运行模式三选一</span>
          <span class="feature-tag">油门曲线自定义</span>
          <span class="feature-tag">刹车力度滑块</span>
          <span class="feature-tag">Boost/Turbo 进角</span>
        </div>
      </div>
      <div class="feature-card">
        <span class="feature-number">02</span>
        <div class="feature-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2v4m0 12v4M4.93 4.93l2.83 2.83m8.48 8.48l2.83 2.83M2 12h4m12 0h4M4.93 19.07l2.83-2.83m8.48-8.48l2.83-2.83"/></svg></div>
        <h3>转速计算与显示</h3>
        <p>基于齿轮比、磁极数、轮胎直径自动计算车辆实际速度。支持 km/h 与 mph 单位切换。圆形仪表盘以青绿色刻度环呈现实时速度值，搭配 RPM / ESC Voltage / ESC Current / Motor Temp 六宫格数据面板，提供全方位运行状态监控。</p>
        <div class="feature-tags">
          <span class="feature-tag">自动转速换算</span>
          <span class="feature-tag">圆形仪表盘</span>
          <span class="feature-tag">六宫格数据面板</span>
          <span class="feature-tag">km/h / mph 切换</span>
        </div>
      </div>
      <div class="feature-card">
        <span class="feature-number">03</span>
        <div class="feature-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg></div>
        <h3>多模式适配</h3>
        <p>支持创建并存储多个独立参数模式（Mode 1/2/3 及更多自定义），每个模式包含完整的 GS/TRC/BS/TA 参数集。支持 Import / Export 导入导出参数配置，Reset 一键恢复默认值，满足不同赛道场景的一键切换需求。</p>
        <div class="feature-tags">
          <span class="feature-tag">多模式存储</span>
          <span class="feature-tag">参数导入导出</span>
          <span class="feature-tag">一键重置</span>
          <span class="feature-tag">场景化切换</span>
        </div>
      </div>
      <div class="feature-card">
        <span class="feature-number">04</span>
        <div class="feature-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg></div>
        <h3>历史数据回溯</h3>
        <p>Data Record 功能记录每次运行的关键数据极值：Max ESC Temperature、Motor Temperature、Min Battery Voltage、Max Motor RPM 等。帮助用户分析设备性能表现，优化参数设置策略，追踪长期使用趋势。</p>
        <div class="feature-tags">
          <span class="feature-tag">温度极值记录</span>
          <span class="feature-tag">电压最低记录</span>
          <span class="feature-tag">RPM 峰值追踪</span>
          <span class="feature-tag">性能趋势分析</span>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- UI Showcase with Rebuilt UI Screens -->
<section class="ui-showcase">
  <div class="container">
    <div class="showcase-intro">
      <div class="section-label">UI Design Showcase</div>
      <h2 class="section-title">界面设计一览</h2>
      <p>以下展示平台核心界面，涵盖参数设置主页、实时监控仪表盘、弹窗交互等核心模块的完整 UI 设计。</p>
    </div>

    <!-- Group 1: Main Screen + Gauge -->
    <div class="gallery-section">
      <div class="gallery-label">核心界面</div>
      <div class="gallery-grid cols-2">
        <div class="ss-card">
          <span class="ss-badge live">LIVE</span>
          <div class="screen-container tall" style="display:flex;">
            <!-- Rebuilt Parameters page mini phone -->
            <div style="width:220px;border-radius:34px;background:linear-gradient(145deg,#1c1c1e,#0a0a0a);padding:2.5px;box-shadow:0 8px 32px rgba(0,0,0,0.5),0 0 0 1px rgba(255,255,255,0.05);">
              <div style="width:100%;aspect-ratio:195/430;background:#0f1115;border-radius:31px;overflow:hidden;position:relative;font-family:'Inter',system-ui,-apple-system,sans-serif;-webkit-font-smoothing:antialiased;">
                <div style="position:absolute;top:7px;left:50%;transform:translateX(-50%);width:62px;height:19px;background:#000;border-radius:13px;z-index:50;"></div>
                <div style="position:absolute;top:0;left:0;right:0;height:44px;display:flex;align-items:center;justify-content:space-between;padding:0 18px;padding-top:12px;z-index:40;font-size:11px;font-weight:600;color:#fff;"><span>9:41</span><div style="display:flex;gap:3px;align-items:center;"><svg width="14" height="10" viewBox="0 0 16 12" fill="#fff"><path d="M2 4h3l2 4V4h3V0H2v4zm0 8h12v-1H2v1z"/></svg><svg width="14" height="10" viewBox="0 0 16 12" fill="#fff"><rect x="1" y="2" width="12" height="8" rx="1.5" stroke="#fff" stroke-width="1" fill="none"/><path d="M14 4.5V7c0 .8-.7 1.5-1.5 1.5H13V4.5h1z" fill="#fff"/></svg></div></div>
                <div style="position:absolute;top:44px;left:0;right:0;bottom:0;display:flex;flex-direction:column;">
                  <div style="display:flex;align-items:center;justify-content:space-between;padding:8px 14px 9px;">
                    <span style="color:#00d4b8;font-size:18px;line-height:1;">&lt;</span>
                    <span style="font-size:15px;font-weight:600;color:#fff;">Parameters</span>
                    <span style="color:#00d4b8;font-size:16px;">&#x1F4F1;</span>
                  </div>
                  <div style="display:flex;align-items:center;justify-content:space-between;margin:2px 11px 0;padding:9px 14px;background:#1a1d24;border-radius:9px;">
                    <span style="font-size:13px;font-weight:500;color:#fff;">Zero Timing</span>
                    <span style="color:#555b64;font-size:10px;font-weight:600;display:flex;gap:6px;"><span>&#x2304;</span><span>&#x2303;</span></span>
                  </div>
                  <div style="padding:6px 11px;flex:1;overflow:hidden;">
                    <div style="display:flex;align-items:center;justify-content:space-between;padding:10px 12px;margin-bottom:1.5px;background:#1a1d24;border-radius:9px;"><span style="font-size:13px;color:#fff;font-weight:500;">Mode 1</span><span style="color:#00d4b8;font-size:13px;opacity:0.7;">&#9998;</span></div>
                    <div style="display:flex;align-items:center;justify-content:space-between;padding:10px 12px;margin-bottom:1.5px;background:#1a1d24;border-radius:9px;"><span style="font-size:13px;color:#fff;font-weight:500;">Mode 2</span><span style="color:#00d4b8;font-size:13px;opacity:0.7;">&#9998;</span></div>
                    <div style="display:flex;align-items:center;justify-content:space-between;padding:10px 12px;margin-bottom:1.5px;background:#1a1d24;border-radius:9px;"><span style="font-size:13px;color:#fff;font-weight:500;">Mode 3</span><span style="color:#00d4b8;font-size:13px;opacity:0.7;">&#9998;</span></div>
                    <div style="display:inline-flex;align-items:center;justify-content:center;margin:5px 0 0;padding:8px 0;border:1.5px dashed #2a2f38;border-radius:9px;color:#00d4b8;font-size:12px;font-weight:500;">+ Add mode</div>
                  </div>
                  <div style="padding:8px 11px 0;flex:1;overflow:hidden;">
                    <div style="height:6px;"></div>
                    <div style="display:flex;align-items:center;justify-content:space-between;padding:10px 12px;margin-bottom:2.5px;background:#1a1d24;border-radius:9px;"><span style="font-size:12px;color:#fff;font-weight:450;">Running Mode</span><span style="font-size:12px;color:#8892a0;">Forward w/ Brake &#x203A;</span></div>
                    <div style="display:flex;align-items:center;justify-content:space-between;padding:10px 12px;margin-bottom:2.5px;background:#1a1d24;border-radius:9px;"><span style="font-size:12px;color:#fff;font-weight:450;">Max. Reverse Force</span><span style="font-size:12px;color:#8892a0;">50%</span></div>
                    <div style="display:flex;align-items:center;justify-content:space-between;padding:10px 12px;margin-bottom:2.5px;background:#1a1d24;border-radius:9px;"><span style="font-size:12px;color:#fff;font-weight:450;">Cutoff Voltage</span><span style="font-size:12px;color:#8892a0;">Adjustable 7.2V</span></div>
                    <div style="display:flex;align-items:center;justify-content:space-between;padding:10px 12px;margin-bottom:2.5px;background:#1a1d24;border-radius:9px;"><span style="font-size:12px;color:#fff;font-weight:450;">BEC voltage</span><span style="font-size:12px;color:#8892a0;">6.0V &#x203A;</span></div>
                  </div>
                  <div style="display:flex;align-items:center;justify-content:space-around;padding:7px 0 20px;border-top:0.5px solid rgba(255,255,255,0.06);">
                    <div style="display:flex;flex-direction:column;align-items:center;gap:2px;"><span style="font-size:17px;color:#00d4b8;">&#x2699;</span><span style="font-size:8px;color:#00d4b8;font-weight:500;">参数设置</span></div>
                    <div style="display:flex;flex-direction:column;align-items:center;gap:2px;"><span style="font-size:17px;color:#555b64;">&#x25BD;</span><span style="font-size:8px;color:#555b64;"></span></div>
                    <div style="display:flex;flex-direction:column;align-items:center;gap:2px;"><span style="font-size:17px;color:#555b64;">&#x2302;</span><span style="font-size:8px;color:#555b64;"></span></div>
                    <div style="display:flex;flex-direction:column;align-items:center;gap:2px;"><span style="font-size:17px;color:#555b64;">&#x26F6;</span><span style="font-size:8px;color:#555b64;"></span></div>
                    <div style="display:flex;flex-direction:column;align-items:center;gap:2px;"><span style="font-size:17px;color:#555b64;">&#x2699;</span><span style="font-size:8px;color:#555b64;"></span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ss-caption"><h4>参数设置主页面</h4><p>完整重构的 Parameters 界面 — 下拉选择器 + 模式列表 + General Settings 全部入口 + 底部 Tab 导航栏，青绿强调色贯穿全局。</p></div>
        </div>
        <div class="ss-card">
          <div class="screen-container tall" style="display:flex;">
            <!-- Rebuilt Speed Gauge mini phone -->
            <div style="width:220px;border-radius:34px;background:linear-gradient(145deg,#1c1c1e,#0a0a0a);padding:2.5px;box-shadow:0 8px 32px rgba(0,0,0,0.5),0 0 0 1px rgba(255,255,255,0.05);">
              <div style="width:100%;aspect-ratio:195/430;background:#0f1115;border-radius:31px;overflow:hidden;position:relative;font-family:'Inter',system-ui,-apple-system,sans-serif;-webkit-font-smoothing:antialiased;">
                <div style="position:absolute;top:7px;left:50%;transform:translateX(-50%);width:62px;height:19px;background:#000;border-radius:13px;z-index:50;"></div>
                <div style="position:absolute;top:0;left:0;right:0;height:44px;display:flex;align-items:center;justify-content:space-between;padding:0 18px;padding-top:12px;z-index:40;font-size:11px;font-weight:600;color:#fff;"><span>9:41</span><div style="display:flex;gap:3px;align-items:center;"><svg width="14" height="10" viewBox="0 0 16 12" fill="#fff"><path d="M2 4h3l2 4V4h3V0H2v4zm0 8h12v-1H2v1z"/></svg><svg width="14" height="10" viewBox="0 0 16 12" fill="#fff"><rect x="1" y="2" width="12" height="8" rx="1.5" stroke="#fff" stroke-width="1" fill="none"/><path d="M14 4.5V7c0 .8-.7 1.5-1.5 1.5H13V4.5h1z" fill="#fff"/></svg></div></div>
                <div style="position:absolute;top:44px;left:0;right:0;bottom:0;display:flex;flex-direction:column;align-items:center;padding:12px 0 0;">
                  <div style="font-size:15px;font-weight:600;color:#fff;margin-bottom:16px;">Speed</div>
                  <!-- Group 1: Gauge + Value -->
                  <div style="display:flex;flex-direction:column;align-items:center;">
                    <div style="position:relative;width:180px;height:110px;margin:0 auto;">
                      <svg width="180" height="110" viewBox="0 0 180 110" xmlns="http://www.w3.org/2000/svg">
                        <!-- Arc track bg -->
                        <path d="M 20 90 A 70 70 0 0 1 160 90" fill="none" stroke="#1a1d24" stroke-width="10" stroke-linecap="round"/>
                        <!-- Active arc -->
                        <path d="M 20 90 A 70 70 0 0 1 130 35" fill="none" stroke="#00d4b8" stroke-width="10" stroke-linecap="round"/>
                        <!-- Needle -->
                        <line x1="90" y1="90" x2="128" y2="40" stroke="#00d4b8" stroke-width="2.5" stroke-linecap="round"/>
                        <circle cx="90" cy="90" r="6" fill="#1a1d24" stroke="#00d4b8" stroke-width="2"/>
                      </svg>
                    </div>
                    <!-- Value text below gauge (0px gap from gauge) -->
                    <div style="text-align:center;margin-top:0px;">
                      <span style="color:#fff;font-size:24px;font-weight:700;font-family:'Inter',sans-serif;">8.9</span>
                      <span style="color:#8892a0;font-size:11px;font-family:'Inter',sans-serif;margin-left:2px;">km/h</span>
                    </div>
                  </div>
                  <!-- Group 2: Data grid (30px gap from Group 1) -->
                  <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:6px;width:100%;padding-top:30px;padding-left:14px;padding-right:14px;">
                    <div style="background:#1a1d24;border-radius:8px;padding:8px 4px;text-align:center;"><div style="font-size:9px;color:#8892a0;margin-bottom:2px;">Throttle</div><div style="font-size:13px;font-weight:600;color:#fff;">45%</div></div>
                    <div style="background:#1a1d24;border-radius:8px;padding:8px 4px;text-align:center;"><div style="font-size:9px;color:#8892a0;margin-bottom:2px;">RPM</div><div style="font-size:13px;font-weight:600;color:#fff;">18593</div></div>
                    <div style="background:#1a1d24;border-radius:8px;padding:8px 4px;text-align:center;"><div style="font-size:9px;color:#8892a0;margin-bottom:2px;">Voltage</div><div style="font-size:13px;font-weight:600;color:#fff;">7.9V</div></div>
                    <div style="background:#1a1d24;border-radius:8px;padding:8px 4px;text-align:center;"><div style="font-size:9px;color:#8892a0;margin-bottom:2px;">Current</div><div style="font-size:13px;font-weight:600;color:#fff;">12.3A</div></div>
                    <div style="background:#1a1d24;border-radius:8px;padding:8px 4px;text-align:center;"><div style="font-size:9px;color:#8892a0;margin-bottom:2px;">ESC Temp</div><div style="font-size:13px;font-weight:600;color:#00d4b8;">44&#xB0;C</div></div>
                    <div style="background:#1a1d24;border-radius:8px;padding:8px 4px;text-align:center;"><div style="font-size:9px;color:#8892a0;margin-bottom:2px;">Motor T</div><div style="font-size:13px;font-weight:600;color:#fff;">38&#xB0;C</div></div>
                  </div>
                  <div style="display:flex;align-items:center;justify-content:space-around;padding:7px 0 20px;border-top:0.5px solid rgba(255,255,255,0.06);margin-top:auto;">
                    <div style="display:flex;flex-direction:column;align-items:center;gap:2px;"><span style="font-size:17px;color:#555b64;">&#x2699;</span><span style="font-size:8px;color:#555b64;">参数设置</span></div>
                    <div style="display:flex;flex-direction:column;align-items:center;gap:2px;"><span style="font-size:17px;color:#555b64;">&#x25BD;</span><span style="font-size:8px;color:#555b64;"></span></div>
                    <div style="display:flex;flex-direction:column;align-items:center;gap:2px;"><span style="font-size:17px;color:#00d4b8;">&#x2302;</span><span style="font-size:8px;color:#00d4b8;">首页</span></div>
                    <div style="display:flex;flex-direction:column;align-items:center;gap:2px;"><span style="font-size:17px;color:#555b64;">&#x26F6;</span><span style="font-size:8px;color:#555b64;"></span></div>
                    <div style="display:flex;flex-direction:column;align-items:center;gap:2px;"><span style="font-size:17px;color:#555b64;">&#x2699;</span><span style="font-size:8px;color:#555b64;"></span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ss-caption"><h4>实时速度监控仪表盘</h4><p>品牌核心视觉组件 — 青绿色弧形刻度表盘显示实时车速 8.9 km/h，下方六宫格数据面板同步展示 Throttle/RPM/Voltage/Current/温度等关键指标。</p></div>
        </div>
      </div>
    </div>

    <!-- Group 2: Popups & Interactions -->
    <div class="gallery-section">
      <div class="gallery-label">交互细节 & 弹窗控件</div>
      <div class="gallery-grid cols-3">
        <div class="ss-card">
          <div class="screen-container compact" style="display:flex;">
            <!-- Rebuilt popup mini -->
            <div style="width:190px;border-radius:30px;background:linear-gradient(145deg,#1c1c1e,#0a0a0a);padding:2.5px;box-shadow:0 8px 32px rgba(0,0,0,0.5);">
              <div style="width:100%;aspect-ratio:195/380;background:#0f1115;border-radius:27px;overflow:hidden;position:relative;font-family:'Inter',system-ui,-apple-system,sans-serif;">
                <div style="position:absolute;top:7px;left:50%;transform:translateX(-50%);width:54px;height:17px;background:#000;border-radius:11px;z-index:50;"></div>
                <div style="position:absolute;top:0;left:0;right:0;bottom:0;display:flex;flex-direction:column;">
                  <!-- Dimmed background content -->
                  <div style="padding:50px 12px 8px;opacity:0.3;">
                    <div style="height:8px;background:#1a1d24;border-radius:6px;margin-bottom:4px;"></div>
                    <div style="height:8px;background:#1a1d24;border-radius:6px;margin-bottom:4px;"></div>
                    <div style="height:8px;background:#1a1d24;border-radius:6px;margin-bottom:4px;"></div>
                  </div>
                  <!-- Overlay -->
                  <div style="flex:1;background:rgba(0,0,0,0.5);display:flex;flex-direction:column;justify-content:flex-end;">
                    <div style="background:#1e2028;border-radius:16px 16px 0 0;padding:12px 0 22px;">
                      <div style="display:flex;align-items:center;justify-content:space-between;padding:0 14px 10px;">
                        <span style="font-size:14px;font-weight:600;color:#fff;">Cutoff Voltage</span>
                        <span style="color:#555b64;font-size:18px;line-height:1;">&times;</span>
                      </div>
                      <div style="padding:10px 14px;font-size:13px;color:#8892a0;">Disabled</div>
                      <div style="padding:10px 14px;font-size:13px;color:#fff;background:rgba(0,212,184,0.12);font-weight:550;">Auto</div>
                      <div style="padding:10px 14px;font-size:13px;color:#8892a0;">Adjustable</div>
                      <div style="margin:8px 14px 0;padding:9px 0;text-align:center;border:1.5px solid #00d4b8;border-radius:9px;color:#00d4b8;font-size:13px;font-weight:600;">Confirm</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ss-caption"><h4>底部选项弹窗</h4><p>Cutoff Voltage 三档选择弹窗 — Disabled/Auto/Adjustable，"Auto" 高亮选中态 + 青绿色 Confirm 按钮。</p></div>
        </div>
        <div class="ss-card">
          <div class="screen-container compact" style="display:flex;">
            <!-- Rebuilt slider mini -->
            <div style="width:190px;border-radius:30px;background:linear-gradient(145deg,#1c1c1e,#0a0a0a);padding:2.5px;box-shadow:0 8px 32px rgba(0,0,0,0.5);">
              <div style="width:100%;aspect-ratio:195/380;background:#0f1115;border-radius:27px;overflow:hidden;position:relative;font-family:'Inter',system-ui,-apple-system,sans-serif;">
                <div style="position:absolute;top:7px;left:50%;transform:translateX(-50%);width:54px;height:17px;background:#000;border-radius:11px;z-index:50;"></div>
                <div style="position:absolute;top:0;left:0;right:0;bottom:0;display:flex;flex-direction:column;">
                  <div style="padding:46px 14px 8px;">
                    <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:4px;">
                      <span style="color:#00d4b8;font-size:17px;line-height:1;">&lt;</span>
                      <span style="font-size:14px;font-weight:600;color:#fff;">Parameters</span>
                      <span style="color:#00d4b8;font-size:15px;">&#x1F4F1;</span>
                    </div>
                    <div style="background:#1a1d24;border-radius:9px;padding:14px 14px 18px;margin-top:12px;">
                      <div style="display:flex;justify-content:space-between;margin-bottom:12px;">
                        <span style="font-size:13px;color:#fff;">Cutoff Voltage</span>
                        <span style="font-size:13px;color:#00d4b8;font-weight:600;">7.2V</span>
                      </div>
                      <!-- Slider track -->
                      <div style="position:relative;height:6px;background:#2a2f38;border-radius:3px;margin-top:8px;">
                        <div style="position:absolute;left:0;top:0;height:100%;width:33%;background:#00d4b8;border-radius:3px;"></div>
                        <div style="position:absolute;left:33%;top:50%;transform:translate(-50%,-50%);width:18px;height:18px;background:#00d4b8;border-radius:50%;box-shadow:0 0 8px rgba(0,212,184,0.4);"></div>
                      </div>
                      <div style="display:flex;justify-content:space-between;margin-top:6px;">
                        <span style="font-size:10px;color:#555b64;">6.4V</span>
                        <span style="font-size:10px;color:#555b64;">9.6V</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ss-caption"><h4>电压滑块控件</h4><p>Cutoff Voltage Adjustable 模式下的滑块调节器 — 青绿色进度条 + 圆形拖动手柄，范围 6.4V~9.6V，当前值 7.2V。</p></div>
        </div>
        <div class="ss-card">
          <span class="ss-badge new">NEW</span>
          <div class="screen-container compact" style="display:flex;">
            <!-- Rebuilt Blinky mode mini -->
            <div style="width:190px;border-radius:30px;background:linear-gradient(145deg,#1c1c1e,#0a0a0a);padding:2.5px;box-shadow:0 8px 32px rgba(0,0,0,0.5);">
              <div style="width:100%;aspect-ratio:195/380;background:#0f1115;border-radius:27px;overflow:hidden;position:relative;font-family:'Inter',system-ui,-apple-system,sans-serif;">
                <div style="position:absolute;top:7px;left:50%;transform:translateX(-50%);width:54px;height:17px;background:#000;border-radius:11px;z-index:50;"></div>
                <div style="position:absolute;top:0;left:0;right:0;bottom:0;display:flex;flex-direction:column;">
                  <div style="padding:46px 12px 8px;">
                    <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:4px;">
                      <span style="color:#00d4b8;font-size:17px;line-height:1;">&lt;</span>
                      <span style="font-size:14px;font-weight:600;color:#fff;">Parameters</span>
                      <span style="color:#00d4b8;font-size:15px;">&#x1F4F1;</span>
                    </div>
                    <div style="display:flex;align-items:center;justify-content:space-between;margin:2px 10px 0;padding:8px 12px;background:#1a1d24;border-radius:9px;">
                      <span style="font-size:12px;font-weight:500;color:#fff;">Blinky</span>
                      <span style="color:#555b64;font-size:10px;font-weight:600;display:flex;gap:5px;"><span>&#x2304;</span><span>&#x2303;</span></span>
                    </div>
                    <div style="padding:5px 10px;">
                      <div style="display:flex;align-items:center;justify-content:space-between;padding:9px 11px;margin-bottom:1.5px;background:#1a1d24;border-radius:8px;"><span style="font-size:12px;color:#fff;font-weight:500;">1/10 Off-Road</span><span style="color:#00d4b8;font-size:12px;opacity:0.7;">&#9998;</span></div>
                      <div style="display:flex;align-items:center;justify-content:space-between;padding:9px 11px;margin-bottom:1.5px;background:#1a1d24;border-radius:8px;"><span style="font-size:12px;color:#fff;font-weight:500;">1/10 On-Road</span><span style="color:#00d4b8;font-size:12px;opacity:0.7;">&#9998;</span></div>
                      <div style="display:flex;align-items:center;justify-content:space-between;padding:9px 11px;margin-bottom:1.5px;background:#1a1d24;border-radius:8px;"><span style="font-size:12px;color:#fff;font-weight:500;">Blinky</span><span style="color:#00d4b8;font-size:12px;opacity:0.7;">&#9998;</span></div>
                      <div style="display:inline-flex;align-items:center;justify-content:center;margin:4px 0 0;padding:7px 0;border:1.5px dashed #2a2f38;border-radius:8px;color:#00d4b8;font-size:11px;font-weight:500;">+ Add mode</div>
                    </div>
                    <div style="padding:6px 10px 0;">
                      <div style="display:flex;align-items:center;justify-content:space-between;padding:9px 11px;margin-bottom:2px;background:#1a1d24;border-radius:8px;"><span style="font-size:11px;color:#fff;font-weight:450;">Running Mode</span><span style="font-size:11px;color:#8892a0;">Fwd/Rev &#x203A;</span></div>
                      <div style="display:flex;align-items:center;justify-content:space-between;padding:9px 11px;margin-bottom:2px;background:#1a1d24;border-radius:8px;"><span style="font-size:11px;color:#fff;font-weight:450;">BEC voltage</span><span style="font-size:11px;color:#8892a0;">6.0V &#x203A;</span></div>
                    </div>
                  </div>
                  <div style="display:flex;align-items:center;justify-content:space-around;padding:6px 0 18px;border-top:0.5px solid rgba(255,255,255,0.06);margin-top:auto;">
                    <div style="display:flex;flex-direction:column;align-items:center;gap:2px;"><span style="font-size:15px;color:#00d4b8;">&#x2699;</span><span style="font-size:7px;color:#00d4b8;">参数设置</span></div>
                    <div style="display:flex;flex-direction:column;align-items:center;gap:2px;"><span style="font-size:15px;color:#555b64;">&#x25BD;</span><span style="font-size:7px;color:#555b64;"></span></div>
                    <div style="display:flex;flex-direction:column;align-items:center;gap:2px;"><span style="font-size:15px;color:#555b64;">&#x2302;</span><span style="font-size:7px;color:#555b64;"></span></div>
                    <div style="display:flex;flex-direction:column;align-items:center;gap:2px;"><span style="font-size:15px;color:#555b64;">&#x26F6;</span><span style="font-size:7px;color:#555b64;"></span></div>
                    <div style="display:flex;flex-direction:column;align-items:center;gap:2px;"><span style="font-size:15px;color:#555b64;">&#x2699;</span><span style="font-size:7px;color:#555b64;"></span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ss-caption"><h4>Blinky 预设模式页</h4><p>Blinky 设备预设模式视图 — 内置三种车型预设（Off-Road/On-Road/Blinky）+ 自定义编辑，下拉选择器展开为 Blinky 模式组。</p></div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Tech Specs -->
<section class="tech-specs">
  <div class="container">
    <div class="section-header">
      <div class="section-label">Technical Specifications</div>
      <h2 class="section-title">技术规格</h2>
    </div>
    <div class="specs-grid">
      <div class="spec-card"><h4>支持设备型号</h4><div class="spec-value accent">Blinky</div></div>
      <div class="spec-card"><h4>通信方式</h4><div class="spec-value">Bluetooth LE</div></div>
      <div class="spec-card"><h4>软件版本</h4><div class="spec-value">v2.3.0 (Build 230)</div></div>
      <div class="spec-card"><h4>可调参数数量</h4><div class="spec-value accent">50+ 项</div></div>
      <div class="spec-card"><h4>数据记录维度</h4><div class="spec-value">温度 / 电压 / RPM</div></div>
      <div class="spec-card"><h4>语言支持</h4><div class="spec-value">简体中文 / English</div></div>
    </div>
  </div>
</section>

<!-- User Value -->
<section class="user-value">
  <div class="container">
    <div class="section-header">
      <div class="section-label">User Value</div>
      <h2 class="section-title">用户价值</h2>
    </div>
    <div class="value-grid">
      <div class="value-item">
        <div class="value-num">01</div>
        <div class="value-text">
          <h4>专业级参数掌控力</h4>
          <p>从入门到竞技全覆盖。新手可用预设模式快速上手，专业玩家可通过 50+ 项参数精细调控每一毫秒的动力输出特性，实现人车合一的操控境界。</p>
        </div>
      </div>
      <div class="value-item">
        <div class="value-num">02</div>
        <div class="value-text">
          <h4>可视化数据驱动优化</h4>
          <p>不再靠感觉猜测。实时仪表盘 + 历史数据记录让每一次参数调整都有据可依，用数据说话，科学提升赛道成绩。</p>
        </div>
      </div>
      <div class="value-item">
        <div class="value-num">03</div>
        <div class="value-text">
          <h4>场景化一键切换</h4>
          <p>越野、公路、漂移、直线加速 — 不同赛道一套方案。多模式存储与导入导出功能让参数配置像换挡一样简单快捷。</p>
        </div>
      </div>
      <div class="value-item">
        <div class="value-num">04</div>
        <div class="value-text">
          <h4>安全可靠的设备守护</h4>
          <p>热保护阈值设定、低电压截止、异常断连提醒 — 多层安全机制保护昂贵的电调与电机硬件，让你专注比赛而非担忧设备。</p>
        </div>
      </div>
    </div>
  </div>
</section>
</div>

<!-- Page Summary -->
<section class="page-summary">
  <div class="page-summary__inner">
    <p class="page-summary__text fontRegular">{{ detailIntroduction }}</p>
    <div class="page-summary__preview">
      <img
        v-for="(img, index) in previewImages"
        :key="'preview-' + index"
        :src="img"
        alt=""
      />
    </div>
    <div class="page-summary__back fontRegular" @click="goBack">返回</div>
  </div>
</section>

<!-- Related Cases -->
<section class="related-cases">
  <div class="related-cases__inner">
    <div class="related-cases__title">
      <img :src="caseListText" alt="相关案例" />
    </div>
    <div class="related-cases__grid">
      <list-card
        v-for="(item, index) in relatedCaseList"
        :key="'related-case-' + index"
        class="noPadding"
        :src="item.image"
        :routeQuery="item.routeQuery"
        :keyIndex="index"
        :showDownName="false"
        :isRichHtml="true"
        :showFreeTrialTag="item.showFreeTrialTag"
        :backgroundColor="item.backgroundColor"
      />
    </div>
  </div>
</section>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import ListCard from "@/components/list-card/index.vue";
import { initRichHtmlReveal } from "../utils/useRichHtmlReveal";

const posterBanner = require("@/assets/images/richHtml/intelligentElectricAdjustmentSystem/poster1.png");

const onImageError = (event) => {
  const target = event.target;
  if (target) {
    target.style.display = "none";
  }
};

const introduceText = require("@/assets/images/introduce-text.png");
const caseListText = require("@/assets/images/case-list-text.png");

const projectIntroduction =
  "专为遥控模型车设计的专业级电调参数配置与实时监控平台，支持深度参数定制、转速计算、多模式适配与历史数据回溯。云效科技团队深入 RC 模型竞技场景，打造跨平台（iOS / Android / HarmonyOS）智能控制体验，帮助玩家从入门到竞技全面掌控电调性能。";

const detailIntroduction =
  "云效科技崇尚创新，专注研发，拥有一支国内领先的技术团队，并凭借专业知识强、业务技术精、服务质量高、精神面貌佳等特点得到用户的一致赞誉。在软件开发的专业领域，云效科技与行业内诸多知名企业保持有长期稳定的合作关系。";

const previewImages = [
  require("@/assets/images/list-case/attract-investment/image-1.png"),
];

const relatedCaseList = [
  {
    image: require("@/assets/images/project-list-card/project-39.png"),
    backgroundColor: "#1C69C7",
    routeQuery: { name: "intelligentPetFeeder", isRichHtml: true },
  },
  {
    image: require("@/assets/images/project-list-card/project-37.png"),
    backgroundColor: "#09C9B0",
    routeQuery: { name: "lovableHome", isRichHtml: true },
  },
  {
    image: require("@/assets/images/project-list-card/project-35.png"),
    backgroundColor: "#4459FE",
    routeQuery: { name: "channelAdvertisingFundManagementPlatform", isRichHtml: true },
  },
];

const router = useRouter();
const rootRef = ref(null);

const goBack = () => {
  router.go(-1);
};

onMounted(() => {
  initRichHtmlReveal(rootRef.value);
});
</script>

<style lang="scss" src="./case.scss"></style>
<style lang="scss" src="./banner.scss"></style>
<style lang="scss" src="./layout.scss"></style>
